import { useNavigate, useSearchParams } from "react-router-dom";

import { Button, Footer, Header, Main } from "@/components";
import { Step, StepContainer, StepIndicator, StepParagraph, StepsGenerator } from "@/components/step";

import { lanLineStepsData, vmwComadStepsData } from "./dearis-steps-data";

export const DearisHardware = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lineType = searchParams.get("type");

  const stepsData = lineType === "vmw_comad" ? vmwComadStepsData : lanLineStepsData;

  return (
    <>
      <Header>制御装置の設定</Header>
      <Main>
        <StepContainer>
          <StepsGenerator stepsData={stepsData} />
          <Step>
            <StepParagraph>
              <StepIndicator>3</StepIndicator>
              {"リセットボタンを押してください。"}
            </StepParagraph>
            <Button onClick={() => navigate("/pre-setting")}>次へ</Button>
          </Step>
        </StepContainer>
      </Main>
      <Footer />
    </>
  );
};
